import VueRouter from 'vue-router'
import ProjectOverview from './pages/ProjectOverview.vue'
import ProjectOverview2021 from './pages/ProjectOverview2021.vue'
import ProjectOverview2022 from './pages/ProjectOverview2022.vue'
import Impressum from './pages/Impressum.vue'
import Programme from './pages/Programme.vue'
import Programme2021 from './pages/Programme2021.vue'
import Programme2022 from './pages/Programme2022.vue'
import Resources from './pages/Resources.vue'
import OrganisationalMatters from './pages/OrganisationalMatters.vue'
import Home from './pages/Home.vue'

import ProjectEntries  from './data/projects.json'

const blogRoutes = Object.keys(ProjectEntries).map(section => {
  const children = ProjectEntries[section].map(child => ({
    path: child.id,
    name: child.id,
    component: () => import(`./data/projects/${section}/${child.id}.md`)
  }))
  return {
    path: `/${section}`,
    name: section,
    component: () => import('./components/ProjectDetails.vue'),
    children
  }
})

const routes = [
  {
    path: '*',
    name: 'Start',
    component: ProjectOverview
  },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/projects2020',
    name: 'Project 2020',
    component: ProjectOverview
  },
  {
    path: '/projects2021',
    name: 'Project 2021',
    component: ProjectOverview2021
  },
  {
    path: '/projects2022',
    name: 'Project 2022',
    component: ProjectOverview2022
  },
  {
    path: '/imprint',
    name: 'Impressum',
    component: Impressum
  },
  {
    path: '/programme',
    name: 'Programme 2020',
    component: Programme
  },
  {
    path: '/programme2021',
    name: 'Programme 2021',
    component: Programme2021
  },
  {
    path: '/programme2022',
    name: 'Programme 2022',
    component: Programme2022
  },
  {
    path: '/resources',
    name: 'Resources',
    component: Resources
  },
    
  {
    path: '/organisationalmatters',
    name: 'OrganisationalMatter',
    component: OrganisationalMatters
  },
  ...blogRoutes
];

const router = new VueRouter( {
                                //mode: 'history',
                                routes,
                                scrollBehavior: function(to, from, savedPosition) {
                                  if (to.hash) {
                                    return {selector: to.hash}
                                  } else {
                                    return { x: 0, y: 0 }
                                  }
                                }
                              });

export default router;
